import { Component, inject, OnDestroy } from "@angular/core";
import { CardComponent } from "common/card/card.component";
import { MainService } from "core/main.service";
import { CollectedAssociation, ProcessCollectionComponent } from "process/table/process-collection.component";
import { AsyncPipe, NgTemplateOutlet } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { RouterLink } from "@angular/router";
import { DescriptionViewComponent } from "common/editor/description-view.component";

@Component({
	selector: "stages-process-document",
	templateUrl: "./process-document.component.html",
	styleUrls: ["./process-document.component.scss"],
	imports: [TranslateModule, RouterLink, NgTemplateOutlet, DescriptionViewComponent, AsyncPipe],
})
export class ProcessDocumentComponent extends ProcessCollectionComponent implements OnDestroy {
	autoNumber = false;

	constructor() {
		const mainService = inject(MainService);
		const cardComponent = inject(CardComponent, { optional: true });

		super();

		if (!cardComponent) {
			setTimeout(() => {
				mainService.applicationState.documentViewEnabled = true;
			});
		}
	}

	getIndex(association: CollectedAssociation): string {
		return association.sequence!.join(".");
	}

	ngOnDestroy(): void {
		this.mainService.applicationState.documentViewEnabled = false;
	}
}
